import classnames from 'classnames';
import React, { ReactNode } from 'react';

import { BrandHeader } from 'components/BrandHeader';
import { Footer } from 'features/Footer';
import { getLogoUrl } from 'utils/brandLogoUrl';

import { useStyles } from './styles';

export interface ReachApplicationFormLayoutProps {
  brandLogo: string | null;
  brandName: string;
  helpEmail?: string;
  children?: React.ReactNode;
  amazonAccount?: boolean;
  languageSelector?: ReactNode;
  coverImage?: string;
  squareLogo: string | null;
  upsAccount?: boolean;
}

export const ReachApplicationFormLayout: React.FC<
  ReachApplicationFormLayoutProps
> = ({
  brandLogo,
  brandName,
  children,
  helpEmail,
  amazonAccount,
  languageSelector,
  coverImage,
  squareLogo,
  upsAccount,
}) => {
  const classes = useStyles();
  const logoUrl = getLogoUrl(!coverImage ? brandLogo : squareLogo ?? brandLogo);
  const coverImageUrl = getLogoUrl(coverImage);

  return (
    <div className={classes.root}>
      {/* TODO: Add Language banner - https://linear.app/fountain-wxp/issue/AXR-42/language-banner */}
      <main className={classes.content}>
        {coverImage && (
          <img className={classes.cover} src={coverImageUrl} alt="cover" />
        )}
        {/* TODO: Add back button - https://linear.app/fountain-wxp/issue/AXR-41/back-to-job-directory-button-is-missing */}
        <div
          className={classnames({
            [classes.logoBar]: !coverImage,
            [classes.logoBarWithCover]: !!coverImage,
          })}
        >
          {logoUrl && (
            <div
              className={classnames({
                [classes.logoWrapper]: !!coverImage,
                [classes.rectLogoWrapper]: !!coverImage && !squareLogo,
              })}
            >
              <BrandHeader
                brandName={brandName}
                logoUrl={logoUrl}
                className={classnames(classes.logoWithCover, {
                  [classes.squareLogo]: !!coverImage && !!squareLogo,
                  [classes.rectLogo]: !!coverImage && !squareLogo,
                })}
              />
            </div>
          )}
          <div
            className={classnames({
              [classes.languageSelector]: !coverImage,
            })}
          >
            {languageSelector}
          </div>
        </div>
        <div className={classes.form}>{children}</div>
      </main>
      <Footer
        helpEmail={helpEmail}
        isAmazonAccount={amazonAccount}
        isUpsAccount={upsAccount}
      />
    </div>
  );
};
